enum FeatureFlags {
  EnableMultipleMfaMethods = 'auth.enable-multiple-mfa-methods',
  EnableMfaActivationDuringLogin = 'auth.enable-mfa-activation-during-login',
  MarketingBanner = 'core.enable-alternative-login-sidebar-image',
  DisableIdentityProviderForMobile = 'signup.disable-identity-provider-for-mobile',
}

export type FeatureFlagList = {
  [key in keyof typeof FeatureFlags]?: string | boolean;
};

export default FeatureFlags;
